<template>
	<div class="container">
		<div>
			<small><strong>*Por favor proporcione los siguientes datos</strong></small>
			<vs-input 
				type="password"
				class="mt-4"
				label="Contraseña actual" 
				v-model.trim="changePass.password"
				placeholder="Contraseña actual" 
				:state=" (validacionContrasenaActual = getValidationForm('contrasena_actual',validaciones)) ? 'danger' : ''"
                @blur="individualValidateForm('contrasena_actual',changePass.password,validaciones)"	
			>
				<template #message-danger v-if="validacionContrasenaActual" >
					{{validacionContrasenaActual.msg}}
				</template>
			</vs-input>
			<vs-input
				type="password"
				label="Contraseña nueva"
				v-model.trim="changePass.password_new"
				placeholder="Contraseña nueva"
				:state=" (validacionContrasenaNueva = getValidationForm('contrasena_nueva',validaciones)) ? 'danger' : ''"
                @blur="individualValidateForm('contrasena_nueva',changePass.password_new,validaciones)"	
			>
				<template #message-danger v-if="validacionContrasenaNueva" >
					{{validacionContrasenaNueva.msg}}
				</template>
			</vs-input>
			<vs-input
				type="password"
				label="Confirmar Contraseña nueva"
				v-model.trim="changePass.confirm"
				placeholder="Confirmar Contraseña nueva"
				:state=" (validacionConfirmacionContrasenaNueva = getValidationForm('confirmacion_contrasena',validaciones)) ? 'danger' : ''"
                @blur="individualValidateForm('confirmacion_contrasena',changePass.confirm,validaciones)"	
			>
				<template #message-danger v-if="validacionConfirmacionContrasenaNueva" >
						{{validacionConfirmacionContrasenaNueva.msg}}
					</template>
				</vs-input>
		</div>
		<div>
			<small>
				<strong>La nueva contreña debe tener: </strong> <br> 
				Mínimo 8 carateteres, Minusculas, Mayusculas, Números, Caracteres especiales #?!@$%^&*-
			</small>
		</div>
		<div class="d-flex justify-content-end mt-4">
			<vs-button  @click="$emit('verModal',false), cleanInputs()" class="btn-primary-o px-5">Cerrar</vs-button>
			<vs-button @click="putCambiarContrasena()" class="btn-primary pe-0 me-0">Guardar cambios</vs-button>
		</div>
	</div>
</template>
<script>
import NotificationMixin from '@/mixins/ResourceNotificationMixin.js'
import FormValidationMixin from '@/mixins/formulario/FormValidationMixin.js'
import mapHelper from "@/store/modules/common/map-helper";
export default ({
	name: 'changePassword',
	mixins:[NotificationMixin,FormValidationMixin],
	data: function() {
		return {
			errores: false,
			changePass: {
				password: "",
				password_new: "",
				confirm: "",
				device_id: "10001",
				platform: navigator.userAgent
			},		
			validaciones:[
                {
                    input:"contrasena_actual", 
                    validaciones : [ v => !!v || 'Requerido' ],
                    error:false,
                    msg:''
                },
                {
                    input:"contrasena_nueva", 
                    validaciones : [             
                            v => !!v || 'Requerido',
							v => (v && v.length >= 8) || 'Mínimo 8 caracteres',
							v => /[#?!@$%^&*-]/.test(v) || 'Escriba un caracter especial',
							v => /[A-Z]/.test(v) || 'Escriba una mayúscula',
							v => /[a-z]/.test(v) || 'Escriba una minúscula',
							v => /[0-9]/.test(v) || 'Escriba al menos un número'
                        ],
                    error:false,
                    msg:''
                },
                {
                    input:"confirmacion_contrasena", 
                    validaciones : [             
                            v => !!v || 'Requerido',              
                            v => (v && v.length >= 8) || 'Mínimo 8 caracteres',
							v => /[#?!@$%^&*-]/.test(v) || 'Escriba un caracter especial',
							v => /[A-Z]/.test(v) || 'Escriba una mayúscula',
							v => /[a-z]/.test(v) || 'Escriba una minúscula',
							v => /[0-9]/.test(v) || 'Escriba al menos un número',
							v => this.passwordConfirmationRule || 'Las contraseñas no coinciden'
                        ],
                    error:false,
                    msg:''
                }
			]
		}
	},
	computed: {
		passwordConfirmationRule() { return (this.changePass.password_new === this.changePass.confirm)? true : false }
	},
	methods:{
		async putCambiarContrasena(){
            this.errores = (this.changePass.password == '' || this.changePass.password_new =='' || this.changePass.confirm =='')? true : false 
			this.validaciones.forEach(e => { if(e.error) this.errores = true });
			if(this.errores) return;
			
			try {
				// console.log(mapHelper.mapmod.SIAHE_PASSWORD + mapHelper.mapfn.changePassword, this.changePass);
				let result = await this.$store.dispatch(mapHelper.mapmod.SIAHE_PASSWORD + mapHelper.mapfn.changePassword, this.changePass);  
				// console.log(result);      
				if (result.status == 200){
					this.openNotification(null,"success-sh",null,"Exitoso",result.message,null);
					this.$emit('verModal', false);
					this.cleanInputs();
				}else this.openNotification(null,"danger-sh",null,"Error","",null);
			} catch (error){ this.openNotification(null,"danger-sh",null,"Error",error,null); }
		},
		cleanInputs(){
			this.changePass = {
				password: "",
				password_new: "",
				confirm: "",
				device_id: "10001",
				platform: navigator.userAgent
			}
			this.validaciones.forEach(e => { e.error = false });
		}
	}
})
</script>
